import { ReactNode } from "react";
import { Text } from "@focal/ui-kit";
import { Title } from "@/components/common/Title";
import { cn } from "@/lib/utils";

interface SettingsSectionProps {
  /** Section title — renders as h6 visual. */
  title: string;
  /** Optional description shown under the title. */
  description?: string;
  /** "default" renders content inline; "card" wraps it in a bordered box. */
  variant?: "default" | "card";
  /** Section content (form fields, lists, etc.). */
  children: ReactNode;
  /** Optional extra class names appended to the outer wrapper. */
  className?: string;
}

export const SettingsSection = ({
  title,
  description,
  variant = "default",
  children,
  className,
}: SettingsSectionProps) => {
  const isCard = variant === "card";

  return (
    <section
      className={cn(
        "mb-8",
        isCard && "p-4 border border-border-light rounded-xl",
        className,
      )}
    >
      <Title text={title} level="h6" spacing="sm" />
      {description ? (
        <Text variant="p2" textColor="secondary" className="mb-4">
          {description}
        </Text>
      ) : null}
      {children}
    </section>
  );
};
